// item 123 — the guided product tour's PURE state logic, extracted from GuidedTour so
// the auto-show-once gate and step navigation (with clamping) are unit-tested rather
// than living only inside the modal component.

export const TOUR_SEEN_KEY = 'basix.appTourSeen';
export const TOUR_SEEN_VALUE = '1';
export const REPLAY_TOUR_EVENT = 'basix:replay-tour';

// auto-show the tour once per device: only when the "seen" flag has never been set.
export const shouldAutoShowTour = (seen: string | null): boolean => !seen;

export const isLastStep = (step: number, count: number): boolean => step >= count - 1;

// next/prev clamp to the valid range so the step index can never run off the ends.
export const nextStep = (step: number, count: number): number => Math.min(step + 1, count - 1);
export const prevStep = (step: number): number => Math.max(step - 1, 0);
